import { useState } from 'react';
import '../../styles/EduComponents/CallbackForm.css';

const CallbackForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    countryCode: '',
    phone: '',
    email: '',
    reason: '',
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const formBody = new URLSearchParams(formData).toString();

    await fetch(process.env.REACT_APP_CALLBACK_SCRIPT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formBody,
    });

    // Optional success feedback
    alert("Callback request submitted successfully!");

    setFormData({
      firstName: '',
      lastName: '',
      countryCode: '',
      phone: '',
      email: '',
      reason: '',
    });

    onClose();

  } catch (error) {
    console.error("Callback submission failed:", error);
    alert("Something went wrong. Please try again.");
  }
};


  return (
    <div className="callback-overlay">
      <div className="callback-modal">
        <button className="close-btn" onClick={onClose}>×</button>

        <h2>Request a Callback</h2>
        <p>One of our teammates will call you back within 24 hrs.</p>

        <form onSubmit={handleSubmit}>
          <div className="row">
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              required
              value={formData.firstName}
              onChange={handleChange}
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              required
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>

          <div className="row">
            <input
              type="text"
              name="countryCode"
              placeholder="Country Code"
              required
              value={formData.countryCode}
              onChange={handleChange}
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              required
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <input
            type="email"
            name="email"
            placeholder="Email ID"
            required
            value={formData.email}
            onChange={handleChange}
          />

          <textarea
            name="reason"
            placeholder="Reason for Callback"
            rows="4"
            required
            value={formData.reason}
            onChange={handleChange}
          />

          <button type="submit" className="submit-btn">
            Submit Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default CallbackForm;
